module.exports = __webpack_public_path__ + "img/appLogo-color--Onlight.434442e9.svg";